<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="red">
            <h4 class="title">Requests Feed</h4>
            <p class="category">list of all the requests</p>
          </md-card-header>
          <md-card-content>
            <request-feed-table table-header-color="green"></request-feed-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
  import RequestFeedTable from '@/components/Tables/RequestFeedTable.vue'

  export default{
    components: {
      RequestFeedTable
    }
  }
</script>
